import {createNoAuthenticationClient} from "@/http-client";
import {AxiosInstance} from 'axios';
import {EncCandidateProfile} from "@/models/EncCandidateProfile";
import {WizardProgress} from "@/models/WizardProgress";
import { CandidateProfile } from "@/models/CandidateProfile";
import { FileStorage } from "@/models/FileStorage";
import {prefixBaseUrlOneApi} from "@/helper";

export class SignupService {

    private client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    async fromEncryptedId(encryptedId: string): Promise<EncCandidateProfile | null> {
        const response = await this.client.get<EncCandidateProfile>(prefixBaseUrlOneApi + "/kandidaten/directSignUp/enc?encryptedId=" + encodeURIComponent(encryptedId));
        return response.status == 200 ? response.data : null;
    }

    async updateCandidate(profile: EncCandidateProfile): Promise<boolean> {
        const response = await this.client.post(prefixBaseUrlOneApi + `/kandidaten/directSignUp/wizardData`, profile);
        return response.status == 200;
    }

    async setProgressStep(wizardProgress: WizardProgress): Promise<boolean> {
        const response = await this.client.post(prefixBaseUrlOneApi + `/kandidaten/directSignUp/wizardStep`, wizardProgress);
        return response.status === 200;
    }

    async postCV(cv, encryptedId: string, func) {
        const data = new FormData();
        data.append("files", cv);
        data.append("id", encryptedId)
        const config = {
            onUploadProgress: progressEvent => func(progressEvent)
        }
        const response = await this.client.postForm(prefixBaseUrlOneApi + "/kandidaten/directSignUp/cv/", data, config);
        return response.status == 200;
    }

    async getLatestCV(encryptedId) {
        const response = await this.client.get<FileStorage>(prefixBaseUrlOneApi + "/kandidaten/directSignUp/cv/latest?encryptedId=" + encodeURIComponent(encryptedId));
        return response.status == 200 ? response.data : null;
    }

    async getId(): Promise<number | null> {
        throw "not supported";
    }

    async getEmail(): Promise<string | null> {
        throw "not supported";
    }

    async register(profile: CandidateProfile): Promise<boolean> {
        throw "not supported";
    }

    async getWizardStep(encryptedId: string): Promise<number | null> {
        const response = await this.client.get<number | null>(prefixBaseUrlOneApi + "/kandidaten/directSignUp/wizardStep?encryptedId=" + encodeURIComponent(encryptedId));
        return response.status == 200 ? response.data : null;
    }
}


export async function createSignupService(): Promise<SignupService> {
    const client = await createNoAuthenticationClient();
    return new SignupService(client);
}
